'use strict';

angular.module('searchModule')

.controller('RefineFacetGroupInitiativeCompletionStatusController', ['$scope', 'businessPlanningService',
                                                            function ($scope, businessPlanningService) {

    var completionStatuses = [];
    businessPlanningService
        .getPlanLookups()
        .then(function (containerPlanLookups) {

            // Remap controlStatusFacetGroups with Control Assessment
            $scope.refineFacetsById.RefineFacetsByColumnValue =
                    _.chain(containerPlanLookups.CompletionStatuses)
                    .map(function (completionStatus) {
                        var foundRefineFacetGroup = _.find($scope.refineFacetsById.RefineFacetsByColumnValue, { ColumnValue: completionStatus.TitleEN })

                        if (!foundRefineFacetGroup) {
                            foundRefineFacetGroup = completionStatus;
                            foundRefineFacetGroup.RefineFacetsCount = 0;
                            foundRefineFacetGroup.ColumnValue = completionStatus.TitleEN;
                        }

                        return _.assign(completionStatus, foundRefineFacetGroup);
                    })
                    .value();
            $scope.refineFacetsById.DisplayedRefineFacetsByColumnValue = $scope.refineFacetsById.RefineFacetsByColumnValue;
        });

    $scope.toggleControlStatusRefineFacetGroupSelection = function (refineFacetsByColumnValue) {
        if (refineFacetsByColumnValue.RefineFacetsCount === 0) return;

        $scope.toggleRefineFacetSelection(refineFacetsByColumnValue.RefineFacetID, refineFacetsByColumnValue.ColumnValue);
    };

    $scope.getCssClassesForFacetGroup = function (facetGroup) {
        if (facetGroup.RefineFacetsCount > 0) return 'u-pointer';

        return 'u-pointer-normal';
    };

}]);